<!-- 商户结算/商户账户列表 -->
<template>
  <el-table :data="tableData" style="width: 100%;border: 1px solid #f1f1f1">
    <el-table-column
      sortable
      label="编号"
      align="center"
      prop="id"
      width="80"
    ></el-table-column>
    <el-table-column label="商户" prop="name" align="center"></el-table-column>
    <el-table-column
      label="可用余额"
      prop="levelname"
      align="center"
    ></el-table-column>
    <el-table-column
      label="冻结余额"
      prop="number"
      align="center"
    ></el-table-column>
    <el-table-column label="信用信息" align="center">
      <template slot-scope="scope">
        <div class="table_scope_line">信用分：{{ scope.row.xyf }}</div>
        <div class="table_scope_line">信用级别：{{ scope.row.xyjb }}</div>
      </template>
    </el-table-column>
    <el-table-column label="操作" align="center">
      <template slot-scope="scope">
        <div class="table_button_line">
          <el-button type="primary" @click="editShopDetail(scope.row.id)"
            >账户编辑</el-button
          >
          <el-button>冻结详情</el-button>
        </div>
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
export default {
  props: {
    tableData: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  methods: {
    editShopDetail(id) {
      console.log(id);
    }
  }
};
</script>
